import types from 'constants/actionTypes';
import { combineReducers } from 'redux';

const initialState = {
  byId: {},
};

const byId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.byId;
  }

  switch (type) {
    case types.GET_MODEL_COMPETITION_REQUEST_SUCCESS:
      let updatedState = { ...state };
      const modelId = payload.vgModelCode;
      updatedState[modelId] = {
        distributions: payload.distributions,
        compModels: payload.comp_models,
        compModelCode: payload.comp_model_code,
      };
      return updatedState;
    case type.CLEAR_MODEL_COMPETITION_DATA:
      return initialState.byId;
    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
